/* BAE priority-overflow nav.
   Keeps the desktop menu on one line. When it can't fit, the lowest-priority
   items move into a "More" dropdown, in this order (first = first to go):
     About Us -> Contact -> Other Gifts -> Occasion -> Gallery
   Everything is restored automatically when the window grows. */
(function () {
  var HIDE_ORDER = ['About Us', 'Contact', 'Other Gifts', 'Occasion', 'Gallery'];
  var CARET = '<svg class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg>';

  function init() {
    var nav = document.querySelector('.header__inline-menu');
    if (!nav) return;
    var ul = nav.querySelector('.list-menu--inline');
    if (!ul || ul.dataset.baeNav === 'on') return;
    ul.dataset.baeNav = 'on';

    var items = Array.prototype.slice.call(ul.children).filter(function (li) {
      return !li.classList.contains('bae-more');
    });
    if (!items.length) return;

    // snapshot each top-level item: label, own link, child links
    var model = items.map(function (li) {
      var summary = li.querySelector('summary');
      var topLink = li.querySelector(':scope > a');
      var label = (summary ? summary.querySelector('span') : topLink);
      var title = (label ? label.textContent : li.textContent).trim();
      var kids = Array.prototype.slice.call(li.querySelectorAll('.header__submenu a')).map(function (a) {
        return { title: a.textContent.trim(), href: a.getAttribute('href') };
      });
      return { li: li, title: title, href: topLink ? topLink.getAttribute('href') : null, kids: kids };
    });

    // build the More dropdown, reusing Dawn's own classes so it inherits styling
    var more = document.createElement('li');
    more.className = 'bae-more';
    more.hidden = true;
    more.innerHTML =
      '<header-menu><details id="Details-HeaderMenu-bae-more">' +
        '<summary class="header__menu-item list-menu__item link focus-inset" aria-label="More menu items">' +
          '<span>More</span>' + CARET +
        '</summary>' +
        '<ul class="header__submenu list-menu list-menu--disclosure color-scheme-1 gradient caption-large motion-reduce global-settings-popup" role="list" tabindex="-1"></ul>' +
      '</details></header-menu>';
    ul.appendChild(more);
    var moreList = more.querySelector('ul');
    var moreDetails = more.querySelector('details');

    // cache natural widths once everything has rendered
    var widths = null;
    function measure() {
      widths = model.map(function (m) { return m.li.getBoundingClientRect().width; });
    }

    function renderMore(hiddenModels) {
      moreList.innerHTML = '';
      hiddenModels.forEach(function (m) {
        if (m.kids.length) {
          var group = document.createElement('li');
          group.className = 'bae-more__group';
          group.innerHTML = '<span>' + m.title + '</span>';
          moreList.appendChild(group);
          m.kids.forEach(function (k) {
            var li = document.createElement('li');
            li.className = 'bae-more__child';
            li.innerHTML = '<a href="' + k.href + '" class="header__menu-item list-menu__item link link--text focus-inset caption-large">' + k.title + '</a>';
            moreList.appendChild(li);
          });
        } else {
          var li2 = document.createElement('li');
          li2.innerHTML = '<a href="' + (m.href || '#') + '" class="header__menu-item list-menu__item link link--text focus-inset caption-large">' + m.title + '</a>';
          moreList.appendChild(li2);
        }
      });
    }

    // the <ul> is not width-constrained by the nav, so scrollWidth never exceeds
    // clientWidth. Measure the sum of visible items against the nav instead.
    function fits() {
      var avail = nav.clientWidth;
      var used = 0;
      Array.prototype.forEach.call(ul.children, function (li) {
        if (li.classList.contains('bae-nav-hidden') || li.hidden) return;
        used += li.getBoundingClientRect().width;
      });
      return used <= avail + 1;
    }

    function layout() {
      // reset
      model.forEach(function (m) { m.li.classList.remove('bae-nav-hidden'); });
      more.hidden = true;
      if (!widths) measure();

      var hiddenModels = [];
      for (var i = 0; i < HIDE_ORDER.length; i++) {
        if (fits()) break;
        var target = null;
        for (var j = 0; j < model.length; j++) {
          if (model[j].title === HIDE_ORDER[i] && !model[j].li.classList.contains('bae-nav-hidden')) {
            target = model[j]; break;
          }
        }
        if (!target) continue;
        target.li.classList.add('bae-nav-hidden');
        hiddenModels.push(target);
        more.hidden = false;
        renderMore(hiddenModels);
        // force reflow so the next fits() sees the new widths
        void ul.offsetWidth;
      }
      if (!hiddenModels.length) {
        more.hidden = true;
        if (moreDetails) moreDetails.removeAttribute('open');
      }
    }

    var raf, busy = false;
    function schedule() {
      if (busy) return;                       // ignore reflows we cause ourselves
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        busy = true;
        layout();
        requestAnimationFrame(function () { busy = false; });
      });
    }

    // expose a manual re-layout hook (used for QA; harmless in production)
    window.baeNavRelayout = layout;

    layout();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { widths = null; layout(); });
    }
    // watch the nav itself: it can change width without the window resizing
    // (logo/cart width, cart count appearing, zoom, font swap).
    if (window.ResizeObserver) {
      new ResizeObserver(schedule).observe(nav);
    }
    window.addEventListener('resize', schedule, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
